"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useLoadedAt = exports.useIsLoading = exports.useIsLoaded = exports.Loading = void 0;
var _reactRedux = require("react-redux");
var _loading = require("../helpers/loading.js");
var useIsLoading = function useIsLoading() {
  var loading = (0, _reactRedux.useSelector)(function (state) {
    return state.loading;
  });
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  var key = (0, _loading.getLoadingKey).apply(void 0, args);
  if (!key) {
    console.error('Received useIsLoading() with invalid arguments.', {
      key: key,
      args: args
    });
    return false;
  }
  if (key instanceof RegExp) {
    var loadingKeys = loading.keySeq();
    var _iterator = _createForOfIteratorHelper(loadingKeys),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var k = _step.value;
        if (k.match(key)) return true;
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    return false;
  }
  return loading.has(key);
};
exports.useIsLoading = useIsLoading;
var useLoadedAt = function useLoadedAt() {
  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }
  var key = (0, _loading.getLoadingKey).apply(void 0, args);
  if (!key) {
    console.error('Received useLoadedAt() with invalid arguments.', {
      key: key,
      args: args
    });
    return undefined;
  }
  return (0, _reactRedux.useSelector)(function (state) {
    return state.loadedAt.get(key);
  });
};
exports.useLoadedAt = useLoadedAt;
var useIsLoaded = function useIsLoaded() {
  for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    args[_key3] = arguments[_key3];
  }
  var key = (0, _loading.getLoadingKey).apply(void 0, args);
  var loadedAt = (0, _reactRedux.useSelector)(function (state) {
    return state.loadedAt;
  });
  if (!key) {
    console.error('Received useIsLoaded() with invalid arguments.', {
      key: key,
      args: args
    });
    return false;
  }
  return loadedAt.get(key) && loadedAt.has(key);
};
exports.useIsLoaded = useIsLoaded;
var Loading = /*#__PURE__*/_createClass(function Loading(_ref) {
  var _this = this;
  var Responses = _ref.Responses;
  _classCallCheck(this, Loading);
  this.useIsLoading = useIsLoading;
  this.useIsLoaded = useIsLoaded;
  this.useLoadedAt = useLoadedAt;
  this.Responses = Responses;
  this.useIsResponseSyncing = function (quizId, questionId) {
    var responseSyncing = useIsLoading(_this.Responses.responseSync, quizId, questionId);
    return useIsLoading(_this.Responses.responseEvaluate, quizId, questionId) || responseSyncing;
  };
});
exports.Loading = Loading;
;